import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=13a540ac&scoped=true&lang=pug"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"
import style0 from "./Cell.vue?vue&type=style&index=0&id=13a540ac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a540ac",
  null
  
)

export default component.exports